import { NODE_META } from './constants'

export type ViewMode = 'list' | 'grid'
export type NodeType =
  | 'cash_server'
  | 'cm_server'
  | 'mikrotik'
  | 'integration'
  | 'egais_utm'
  | 'chz'
  | 'unknown'

export interface InfraNode {
  id?: number | string
  name?: string
  label?: string
  type?: string
  ip?: string
  status?: string
  ms?: string | number
  [key: string]: unknown
}

export interface PriceChecker {
  id: number | string
  name?: string
  ip?: string
  status?: string
  online?: boolean
}

export interface InfraTableRow extends InfraNode {
  key: string
  nodeId: string
  nodeType: NodeType
  title: string
  typeHint: string
  ping: string | null
}

const VIEW_KEY = 'kit.home.view'

export function readViewMode(): ViewMode {
  try {
    const v = localStorage.getItem(VIEW_KEY)
    if (v === 'list' || v === 'grid') return v
  } catch {
    /* ignore */
  }
  return 'list'
}

export function labelToType(label?: string, type?: string): NodeType {
  const NODE_TYPES: NodeType[] = [
    'cash_server',
    'cm_server',
    'mikrotik',
    'integration',
    'egais_utm',
    'chz',
    'unknown',
  ]
  if (type && NODE_TYPES.includes(type as NodeType)) return type as NodeType
  const l = label || ''
  if (/Кассов/i.test(l)) return 'cash_server'
  if (/СМ|СуперМаг/i.test(l)) return 'cm_server'
  if (/MikroTik/i.test(l)) return 'mikrotik'
  if (/интеграц/i.test(l)) return 'integration'
  if (/ЕГАИС/i.test(l)) return 'egais_utm'
  if (/Честн/i.test(l)) return 'chz'
  return 'unknown'
}

export function formatPing(ms?: string | number) {
  if (ms == null || ms === '' || ms === 'unknown') return null
  const s = String(ms).trim()
  if (!s) return null
  if (/ms/i.test(s)) return s
  if (/^\d+(\.\d+)?$/.test(s)) return `${s}ms`
  return s
}

export function buildInfraRow(node: InfraNode, idx: number): InfraTableRow {
  const nodeType = labelToType(node.label || node.name, node.type)
  const meta = NODE_META[nodeType]
  const title = node.name || node.label || meta.titleHint
  const nodeId = String(node.id ?? idx)
  return {
    ...node,
    key: nodeId,
    nodeId,
    nodeType,
    title,
    typeHint: meta.titleHint,
    ping: formatPing(node.ms),
  }
}

export function isInfraProblematic(
  row: InfraTableRow,
  utm?: Record<string, unknown>,
  chz?: Record<string, unknown>,
): boolean {
  if (row.status === 'offline') return true
  if (utm?.error || chz?.error) return true
  return false
}

export function isCheckerProblematic(statusLabel?: string, checker?: PriceChecker): boolean {
  if (statusLabel && /оффлайн/i.test(statusLabel)) return true
  if (statusLabel && /неизвест/i.test(statusLabel)) return true
  return checker?.online === false
}
